/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { SetGiftsDisabledResponse, SetGiftsDisabledVars } from '../openapi-types.gen.js';

export type { SetGiftsDisabledResponse, SetGiftsDisabledVars } from '../openapi-types.gen.js';

export const useSetGiftsDisabled = createMutationHook<SetGiftsDisabledVars, SetGiftsDisabledResponse, unknown>({
  specName: 'useSetGiftsDisabled',
  path: '/v1/users/me/gifts-disabled',
  method: 'PATCH',
  resolveUrl: (vars: SetGiftsDisabledVars) => `/v1/users/me/gifts-disabled`,
  buildBody: (vars: SetGiftsDisabledVars) => ({ disabled: vars.disabled }),
  parseResponse: (raw: unknown): SetGiftsDisabledResponse => raw as SetGiftsDisabledResponse,
  optimistic: [{
    queryKey: ['accounts', 'viewer'],
    reconcile: false,
    entityGraph: true,
    apply: (prev: any, vars: SetGiftsDisabledVars, queryKey: readonly unknown[], queryClient: any, viewerScope: string, networkScope: string) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyPrivateAccountGiftsDisabledOptimistic as unknown as (prev: any, vars: SetGiftsDisabledVars, queryKey: readonly unknown[], queryClient: any, viewerScope: string, networkScope: string) => any)(next, vars, queryKey, queryClient, viewerScope, networkScope);
      return next;
    },
  }],
  
  
});
